"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const containerStyle = {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '0.55px solid rgb(240 240 240)',
    padding: '2px 5px',
    alignItems: 'center',
};
function PanelHeader(props) {
    const { style = {}, children } = props;
    return (0, jsx_runtime_1.jsxs)("div", { style: { ...containerStyle, ...style }, children: [children, " "] });
}
exports.default = PanelHeader;
